import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-61312c28")

_pushScopeId("data-v-61312c28")
const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "label is-inline-flex is-align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "Distributor Book Cost", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-info-circle" })
], -1)
const _hoisted_5 = {
  key: 0,
  class: "control has-icons-left book-cost-field"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "icon is-left" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-dollar-sign" })
], -1)
const _hoisted_7 = {
  key: 1,
  class: "control book-cost-field"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "k-numerictextbox" }, [
  /*#__PURE__*/_createVNode("input", {
    value: "None found",
    disabled: ""
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_numeric_text_box = _resolveComponent("numeric-text-box")
  const _component_loading = _resolveComponent("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("label", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_tooltip, {
        class: "book-cost-tooltip-icon is-inline ml-2",
        content: _ctx.tooltipContent,
        position: 'bottom',
        filter: 'span'
      }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["content"])
    ]),
    (_ctx.distributorBookCost ?? 0 > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_numeric_text_box, {
            value: _ctx.distributorBookCost,
            format: _ctx.priceFormat,
            spinners: false,
            disabled: "",
            placeholder: "Distributor Book Cost",
            name: "distributorBookCost"
          }, null, 8, ["value", "format"]),
          _hoisted_6
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_7, [
          _hoisted_8
        ])),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_loading, {
          key: 2,
          class: "for-field"
        }))
      : _createCommentVNode("", true)
  ]))
})